import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

import { Button } from "reactstrap";

const PdfViewer = ({ pdfFile, fileName }) => {
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = pdfFile;
    link.download = fileName;
    link.click();
  };
  return (
    <div style={{ height: "100%", width: "100%" }} className="text-center">
      <Worker
        workerUrl={`https://unpkg.com/pdfjs-dist@2.15.349/build/pdf.worker.min.js`}
      >
        <Viewer fileUrl={pdfFile} />
      </Worker>
      <div className="py-3">
        {" "}
        <Button onClick={handleDownload} color="primary" size="sm">
          Download PDF
        </Button>
      </div>
    </div>
  );
};

export default PdfViewer;
